export const BUSINESS = {
  name: "Manasa Consumer Electronic Services",
  tagline: "Post-warranty repair & installation for every electronic in your home.",
  phones: [
    { display: "+91 97046 68885", raw: "+919704668885" },
    { display: "+91 95155 98885", raw: "+919515598885" },
  ],
  whatsapp: "+919704668885",
  whatsappText:
    "Hi Manasa Consumer Electronic Services! I'd like to get a quote for an appliance repair/installation. My appliance: ",
  email: "manasacustomercareservice@gmail.com",
  addressName: "Manasa Customer Care Service",
  addressLines: [
    "H.No 81-284/OU377, Plot No. 377",
    "First Floor, OU Colony, Shaikpet",
    "Circle 18, Hyderabad",
  ],
  mapQuery: "Manasa Customer Care Service, Plot No 377, OU Colony, Shaikpet, Hyderabad",
  get mapEmbed() {
    return `https://www.google.com/maps?q=${encodeURIComponent(this.mapQuery)}&output=embed`;
  },
  get mapLink() {
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(this.mapQuery)}`;
  },
  hours: [
    { day: "Mon – Sun", time: "09:00 — 20:00" },
    { day: "Open all week", time: "Incl. holidays" },
  ],
  brands: ["MITSUBISHI", "SAMSUNG", "LG", "PANASONIC", "DAIKIN", "SONY", "WHIRLPOOL", "VOLTAS"],
};

export const SERVICES = [
  { no: "01", title: "TV & Display", desc: "Panel, backlight, power-supply and mainboard repair for LED & smart TVs." },
  { no: "02", title: "Washing Machines", desc: "Front-load and top-load motor, drum, drain and control-board restoration." },
  { no: "03", title: "Refrigerators", desc: "Cooling faults, compressors, thermostats and sealed-system leak repair." },
  { no: "04", title: "AC Repair & Service", desc: "Split, window & inverter AC diagnostics, gas refill, PCB & compressor repair." },
  { no: "05", title: "Microwave & Kitchen", desc: "Magnetrons, fuses and controls for ovens, mixers and induction units." },
  { no: "06", title: "Installation & Wiring", desc: "New appliance installation, safe wiring, stabilisers and MCB fitting." },
];

export const TESTIMONIALS = [
  { quote: "My Samsung TV panel was repaired in two days at nearly half the service-centre quote. Genuine parts and very neat work.", name: "Rajesh K.", area: "Shaikpet" },
  { quote: "AC gas refill and full service done the same day I called. Technicians were professional and explained everything clearly.", name: "Sowmya R.", area: "Manikonda" },
  { quote: "LG washing machine drum issue fixed at home itself. Transparent pricing, no hidden charges at all.", name: "Imran S.", area: "Tolichowki" },
  { quote: "They installed and wired my new fridge and microwave perfectly. Quick response on WhatsApp too. Highly recommended.", name: "Lakshmi D.", area: "OU Colony" },
  { quote: "Mitsubishi AC PCB repair that two other shops refused — Manasa fixed it in a week with a proper warranty on the work.", name: "Venkat P.", area: "Film Nagar" },
];

export const MANIFESTO = [
  { no: "01", title: "Genuine spare parts, always.", desc: "We fit only authentic, company-grade spare parts — never cheap substitutes — so your appliance runs longer and safer after every repair." },
  { no: "02", title: "Company-trained technicians.", desc: "Our engineers are trained by the respective brands and carry years of hands-on experience from authorised service centres." },
  { no: "03", title: "Timely service, affordable cost.", desc: "Fast turnaround and honest, transparent pricing — the same expert repair as a brand service centre, at a much more affordable cost." },
];
